const initialData = {
  nome: '',
  email: '',
};

export default initialData;
